import React from "react";
import { cx } from "../utils";

const CcTheme = ({ as: Component = "div", className, ...props }) => (
  <Component className={cx("cc-theme", className)} {...props} />
);

export default CcTheme;
